import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🧾", key: "serviceHistory" },
  { emoji: "🛞", key: "partsAndUpgrades" },
  { emoji: "⛽", key: "fuelAndCosts" },
  { emoji: "📸", key: "photosAndCondition" },
]

export default function CarsMustTrackPage() {
  return <RadioCardListPage translationKey="carsMustTrack" options={OPTIONS} />
}
